import api from "../api";

const endpoint = "/volontariat/SQCForm";
export const SQCFormulaireService = {
  async insert(data) {
    try {
      const result = await api.post(endpoint + "/create", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data) {
    try {
      const result = await api.put(endpoint + "/update", data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async findOneById(id) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { ext_sqc_form_id: id },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async list(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(id) {
    try {
      const result = await api.post(endpoint + "/delete", {
        ext_sqc_form_id: id,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
